import React, { useEffect, useState } from 'react';
import {Fab, Grid, MenuItem, Select, Switch, TextField} from "@material-ui/core";
import { connect } from "react-redux";
import { compose, graphql } from "react-apollo";
import { NotificationManager } from "react-notifications";
import {webFont} from "../../config/theme";

import { chefCancellationPolicy } from '../../graphql/mutations/chef/create_chef';
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";

import style from "./style";

const CancelationPolicyComponent = (props) => {
  const defPolicy = !!props.details && !!props.details.chef && props.details.chef.cancellationPolicy ? props.details.chef.cancellationPolicy : {} ;
  const [loading, setLoading] = useState(false);
  const [allowCancellation, setAllowCancellation] = useState(defPolicy.allowCancellation || true);
  const [timeBeforeCancellation, setTimeBeforeCancellation] = useState(typeof defPolicy.timeBeforeCancellation === 'number' ? defPolicy.timeBeforeCancellation : 8);
  const [timeBeforeCancellationMetric, setTimeBeforeCancellationMetric] = useState(defPolicy.timeBeforeCancellationMetric || 'hour(s)');
  const [penaltyCharge, setPenaltyCharge] = useState(typeof defPolicy.penaltyCharge === 'number' ? defPolicy.penaltyCharge : 50);
  const [penaltyChargeMetric, setPenaltyChargeMetric] = useState(defPolicy.penaltyChargeMetric || 'percentage');
  const [comments, setComments] = useState(defPolicy.comments || '');
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (props.details) {
      try {
        props.details.refetch();
      } catch (e) {}
    }
  }, [props]);

  useEffect(() => {
    if (props.details) {
      if (props.details.chef) {
        if (props.details.chef.cancellationPolicy) {
          const policy = props.details.chef.cancellationPolicy;
          setAllowCancellation(policy.allowCancellation);
          setTimeBeforeCancellation(typeof policy.timeBeforeCancellation === 'number' ? policy.timeBeforeCancellation : 8);
          setTimeBeforeCancellationMetric(policy.timeBeforeCancellationMetric || 'hour(s)');
          setPenaltyCharge(typeof policy.penaltyCharge === 'number' ? policy.penaltyCharge : 50);
          setPenaltyChargeMetric(policy.penaltyChargeMetric || 'percentage');
          setComments(policy.comments || '');
        }
      }
    }
  }, [props.details]);

  useEffect(() => {
    if (!allowCancellation) {
      // setTimeBeforeCancellation(8);
      // setPenaltyCharge(50);
    }
  }, [allowCancellation, timeBeforeCancellation, penaltyCharge]);

  const handleOnClick = () => {
    if (allowCancellation) {
      if (typeof timeBeforeCancellation === 'string' || typeof penaltyCharge === 'string' || timeBeforeCancellation < 0 || penaltyCharge < 0) {
        NotificationManager.error('Time and Penalty charge are mandatory fields', 'Mandatory fields');
        return;
      }
    }

    const payload = {
      allowCancellation,
      timeBeforeCancellation,
      timeBeforeCancellationMetric,
      penaltyCharge,
      penaltyChargeMetric
    };

    if (comments) {
      payload.comments = comments;
    }

    try {
      setLoading(true);
      props.manageCancelationPolicy({
        variables: {
          id: props.userId,
          cancelationPolicy: payload
        }
      })
        .then(() => {
          setLoading(false);
          NotificationManager.info('Cancelation policy has been updated', 'Cancelation policy');
          setDisabled(true);
        });
    } catch (e) {
      setLoading(false);
      let errorObj = JSON.parse(JSON.stringify(e));
      console.log(errorObj);
      if (errorObj.graphQLErrors) {
        errorObj.graphQLErrors.map(error => {
          NotificationManager.error(error.message, "Add Dish");
        });
      }
    }
  };

  return (
    <div className="">
      <div className="schedule-head-col">
        <div data-test-id={"canclheading-id"} className="header-step-col">
          <p className="located-text" style={style.headerText}>
            Cancelation policy
          </p>
        </div>
        <p style={style.subHeaderText}>
          Please indicate if you will allow diners to cancel an engagement with you and if yes, what the terms of cancelation would be.
        </p>
      </div>

      <Grid container>
        <Grid data-test-id={"allowcan-id"} item xs={12} style={{ display: "flex" }}>
          <p
            style={{
              fontSize: 24,
              fontFamily: webFont,
              fontWeight: 500
            }}
          >
            Allow Cancelation
          </p>
          <div style={{ marginTop: 22 }}>
            <Switch
              data-test-id="allowCancellationStep"
              checked={allowCancellation}
              onChange={() => {
                setAllowCancellation(!allowCancellation);
                setDisabled(false);
              }}
            />
          </div>
        </Grid>
      </Grid>

      {allowCancellation && <>
        <Grid container>
          <Grid item xs={12}>
            Time period before which the cancelation is allowed free of cost.
          </Grid>
          <Grid data-test-id={"cantime-id"} item xs={6} sm={4} md={2}>
            <TextField
              name="timeBeforeCancellation"
              placeholder="Time period"
              style={style.inputBox}
              type="number"
              value={timeBeforeCancellation}
              onChange={(evt) => {
                const val = evt.target.value;
                setTimeBeforeCancellation(val);
                setDisabled(false);

                if (!isNaN(parseInt(val))) {
                  const timeB4Cancel = parseInt(val);
                  if (timeB4Cancel < 1) {
                    setTimeBeforeCancellation(1);
                  } else {
                    setTimeBeforeCancellation(timeB4Cancel);
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={1} />
          <Grid data-test-id={"canhr-id"} item xs={5} sm={7} md={9}>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              value={timeBeforeCancellationMetric}
              onChange={evt => {
                setTimeBeforeCancellationMetric(evt.target.value);
                setDisabled(false);
              }}
              style={style.inputBox}
            >
              <MenuItem value="hour(s)">Hours</MenuItem>
              <MenuItem value="day(s)">Days</MenuItem>
            </Select>
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 30 }}>
          <Grid item xs={12}>
            Penalty charges (not more than booking amount) to be paid after the above time passes.
          </Grid>
          <Grid data-test-id={"penchar-id"} item xs={6} sm={4} md={2}>
            <TextField
              name="penaltyCharge"
              placeholder="Penalty (%)"
              style={style.inputBox}
              type="number"
              value={penaltyCharge}
              onChange={(evt) => {
                const val = evt.target.value;
                setPenaltyCharge(val);
                setDisabled(false);

                if (!isNaN(parseInt(val))) {
                  if (parseInt(val) > 100) {
                    setPenaltyCharge(100);
                  } else if (parseInt(val) < 0) {
                    setPenaltyCharge(0);
                  } else {
                    setPenaltyCharge(parseInt(val));
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={1} />
          <Grid data-test-id={"perccan-id"} item xs={5} sm={7} md={9}>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              value={penaltyChargeMetric}
              onChange={evt => {
                setPenaltyChargeMetric(evt.target.value);
                setDisabled(false);
              }}
              style={style.inputBox}
            >
              <MenuItem value="percentage">Percentage</MenuItem>
            </Select>
          </Grid>
        </Grid>

        <Grid container style={{ marginTop: 30 }}>
        <Grid data-test-id={"canccomm-id"} item xs={12}>
          <TextField
            placeholder="Comments for the diner (if any)"
            inputProps={{ 'data-test-id': 'cpcommentsstep' }}
            multiline
            variant="outlined"
            rows="5"
            fullWidth
            value={comments}
            onChange={evt => {
              setComments(evt.target.value ? evt.target.value : null);
              setDisabled(false);
            }}
          />
        </Grid>
      </Grid>
      </>}

      <Grid contianer>
        <Grid item
              lg={12}
              md={12}
              sm={12}
              style={{ textAlign: "right", marginTop: 20 }}>
          <Fab data-test-id={"subbtncan-id"}
            className="mt-5"
            variant={"extended"}
            disabled={disabled}
            type="button"
            id={"submit-cancelation"}
            style={
              disabled
                ? style.submitButtonDisabled
                : style.submitButton
            }
            onClick={handleOnClick}
          >
            Update policy
          </Fab>
        </Grid>
      </Grid>

    </div>
  );
};

const CancelationPolicy = compose(
  graphql(chefCancellationPolicy, { name: 'manageCancelationPolicy' }),
  graphql(GET_CHEF_DETAILS, {
    name: "details",
    options: props => ({
      variables: {
        id: props.userId
      }
    })
  }),
)(CancelationPolicyComponent);

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef
  };
};

export default connect(mapStateToProps)(CancelationPolicy);
